import { render, staticRenderFns } from "./PrematchDetailPage.vue?vue&type=template&id=50dcf0eb"
import script from "./PrematchDetailPage.vue?vue&type=script&lang=js"
export * from "./PrematchDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports